import { Component } from "react"
import PropTypes from "prop-types"
import _map from "lodash/map"

export default class PopularServicesChart extends Component {
  constructor(props) {
    super(props)
  }

  async componentDidMount() {
    const Highcharts = await import("highcharts")
    Highcharts.setOptions(window.globalHighchartsOptions)

    const Treemap = await import("highcharts/modules/treemap").then(module => module?.default)
    Treemap(Highcharts)

    let data = _map(this.props.data, row => {
      return {
        value: parseInt(row.total_recipes, 10),
        id: row.other_channel_id,
        name: row.name,
        monochrome_image_url: `//assets.ifttt.com/images/channels/${row.other_channel_id}/icons/monochrome_large.png`,
        color: `#${row.color_hsl}`,
        module_name: row.module_name,
      }
    })

    this.chart = new Highcharts.Chart({
      chart: {
        renderTo: this.chartContainer,
        spacing: [0, 0, 0, 0],
        type: "treemap",
      },
      credits: { enabled: false },
      series: [
        {
          animation: false,
          borderWidth: 4,
          borderColor: "#fff",
          data,
          dataLabels: {
            useHTML: true,
            zIndex: 2,
            formatter() {
              const w = this.point.shapeArgs.width
              const h = this.point.shapeArgs.height
              const min = Math.min(w, h)
              let size

              if (min > 96) {
                size = "l"
              } else if (min > 64) {
                size = "m"
              } else if (min > 48) {
                size = "s"
              } else {
                size = "xs"
              }

              return `<div><img class='treemap-icon ${size}' src="${this.point.monochrome_image_url}" /></div>`
            },
          },
          layoutAlgorithm: "squarified",
          margin: 4,
          states: {
            hover: {
              enabled: false,
            },
          },
        },
      ],
      title: "",
      tooltip: {
        borderWidth: 0,
        backgroundColor: "rgba(255,255,255,0)",
        shadow: false,
        useHTML: true,
        formatter() {
          return `<div class="analytics-tooltip analytics-treemap-tooltip" style='z-index: 1000 !important; background-color: ${this.point.color}'>
              <p><img alt="${this.point.id}" src="${this.point.monochrome_image_url}" style="width: 60px"/></p>
              <h3>${this.point.name}</h3>
              <p>${this.point.value}</p>
            </div>`
        },
      },
    })
  }

  componentWillUnmount() {
    this.chart.destroy()
  }

  render() {
    return (
      <div
        className="chart-container popular-services"
        ref={c => (this.chartContainer = c)}
      />
    )
  }
}

PopularServicesChart.propTypes = {
  data: PropTypes.array.isRequired,
}
